import { Dispatch, SetStateAction, useState } from "react";

import { FileIconsDownloadIcon } from "@dotnet/telematics-design-system";

import { DriversFileDataDto } from "../../../../../Pages/Files";
import { DRIVER_FILES_ACTIONS } from "../../../../../shared";
import { useFileDownload } from "../../../hooks";

const useDriverFilesInlineActions = () => {
  const { downloadFile } = useFileDownload();

  const [rowData, setRowData] = useState<DriversFileDataDto | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openDialog = (data: any) => {
    setRowData(data);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setRowData(null);
    setIsOpen(false);
  };

  const handleClick = (
    data: DriversFileDataDto,
    setIsButtonDownload?: Dispatch<SetStateAction<boolean>> | undefined
  ) =>
    downloadFile({
      queryString: data.id,
      setIsLoading: setIsButtonDownload
    });

  const inlineActions = [
    {
      title: DRIVER_FILES_ACTIONS.Download,
      hasLoader: true,
      icon: <FileIconsDownloadIcon />,
      clickAction: handleClick,
      renderConditions: () => true
    }
  ];

  return {
    inlineActions,
    rowData,
    isOpen,
    openDialog,
    closeDialog
  };
};

export default useDriverFilesInlineActions;
